import { UpdateTripDetailsForAdminState } from './updateTripDetailsForAdmin.types'

const initialState: UpdateTripDetailsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
